import { applyUrlMappings, isDiscordActivity } from './discord.ts';
import { mountApp } from './ui/app.ts';
import './styles.css';

if (isDiscordActivity()) {
  applyUrlMappings();
}

const app = document.getElementById('app');
if (!app) {
  throw new Error('elemento #app nao encontrado');
}

mountApp(app).catch((err) => {
  console.error('[main] falha ao iniciar app', err);
  app.innerHTML = `<div class="fatal">erro ao iniciar: ${escapeHtml(err.message)}</div>`;
});

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
